import React, {Fragment} from "react";
import IdaIsi from "./isi-ida";
import MiniDrawer from "./psp-ida";
import {useInView} from "react-intersection-observer";


export default function IdaIsiContainer({showIsiTray, references}) {
    let myThreshold = 0.24;
    if (typeof window !== 'undefined') {
        if (sessionStorage.getItem('collapsePSP')) {
            myThreshold = 0.05;
        }
    }
    const {ref, inView} = useInView({
        threshold: myThreshold,
        initialInView: true
    });

    let isiTray = null;
    if (showIsiTray !== false) {
        isiTray = <MiniDrawer
            siteAudience='ida'
            stickyFlag={inView ? 'hidden' : 'visible'}
            references={references} />;
    }

    return (
        <Fragment>
            <IdaIsi
                observerFlag={ref}
                references={references} />

            {isiTray}
        </Fragment>
    )
}